import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import translate_word from "../../utils/translate";
const selectedMasterHook = (props) => {
    const [location, setLocation] = useState("");
    const [show, setShow] = useState(false);
    const translate = useSelector(state => state.translate);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const router = useRouter();
    var rad = function (x) {
        return x * Math.PI / 180;
    };
    const service_string = () => {
        const array = props.profession ? props.profession?.sort(function (a, b) {
            return a.id - b.id;
        }) : [];
        let str = '';
        for (let index = 0; index < array.length; index++) {
            const el = array[index];
            str += `${el?.service_name_en}${array.length !== index + 1 ? ", " : ""}`;
        }
        return str;
    };
    var getDistance = function (p1, p2) {
        if (p1.lat && p2.lng && p1.lng && p2.lat) {
            var R = 6378137; // Earth’s mean radius in meter
            var dLat = rad(p2.lat - p1.lat);
            var dLong = rad(p2.lng - p1.lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            var value = Math.floor(d / 1000);
            // setLocation(value);
            return value; // returns the distance in meter
        }
    };
    useEffect(() => {
        if (props.geolocation) {
            getDistance({ lat: props.lat, lng: props.lng }, props.address);
        }
    }, []);
    return { location, show, translate, router, dispatch, getDistance, service_string };
};
export default selectedMasterHook;